import * as path from 'path';

/**
 * Gets the relative path from A to B.
 * Usage:
 * const sourcePath = '/home/user/documents/projectA/';
 * const targetPath = '/home/user/images/';
 * const relativePath = getRelativePath(sourcePath, targetPath);
 * @param pathA path to A
 * @param pathB path to B
 * @returns 
 */
export function getRelativePath(pathA: string, pathB: string): string {
    return path.relative(pathA, pathB).replaceAll('\\', '\/').replace('..\/', '');
}
